import { forwardRef } from 'react';
import { styled } from 'goober';

import { EllipsisTextTooltip } from '@/ui/table/infinite-table/ellipsis-text-tooltip';
import { StatusTag } from '@/ui/tag/status-tag';

type ListStatusTagProps = { text: string | null; maxWidth?: string };

export const ProjectTypeTag = ({ text }: ListStatusTagProps) => {
  return (
    <StatusTag variant="gray" bordered isVisible={!!text}>
      <EllipsisTextTooltip Component={<EllipsisText />} text={text} />
    </StatusTag>
  );
};

const EllipsisText = styled('p', forwardRef)`
  ${({ theme }) => theme.mixins.ellipsis}
  font-family: ${({ theme }) => theme.fonts.inter};
  max-width: 180px;
  font-size: 12px;
`;
